export default {
  namespaced: true,
  state: {
    isNavbarVisible: true,
  },
  mutations: {
    isNavbarVisible(state, isNavbarVisible) {
      state.isNavbarVisible = isNavbarVisible;
    },
  },
};
